import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setUserData } from "@/store/slices/UserDataSlice";
import { initializationRules } from "@/components/Reports/state/roster/rules";
import services from '@/components/Reports/services/roster';
import actions from '@/components/Reports/state/roster/actions';
import types from '@/components/Reports/state/roster/constants';
import { RootState } from '@/models/RootState.type';

export const addRosterListenerMiddleware = (listenerMiddleware: ReturnType<typeof createListenerMiddleware>) => {
  listenerMiddleware.startListening({
    actionCreator: setUserData,
    effect: async (action, listenerApi) => {
      const state = listenerApi.getState() as RootState;
      if(state?.userData?.districtId && state?.userData?.schools?.length > 0)
      initializationRules(services.fetchRoster).then((data: any) => {
          listenerApi.dispatch(actions[types.ROSTER_SELECT](data))
        }).catch((e: any) => {
          listenerApi.dispatch(actions[types.ROSTER_ERROR](e.message))
        })
    },
  });
}